(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bundle-addons"] && !Shopify.designMode) return;
  try {
    (function () {
    const fieldset = document.querySelector('[data-product-addons]');
    if (!fieldset) return;
    const form = document.getElementById('product-form');
    if (!form) return;

    // On submit, inject items[][id] and items[][quantity] for each checked addon.
    form.addEventListener('submit', function (e) {
      // Remove any previously-injected fields (in case of double-submit)
      form.querySelectorAll('input[data-addon-injected]').forEach(n => n.remove());

      const checked = fieldset.querySelectorAll('.product__addons-check:checked');
      if (checked.length === 0) return;

      // Shopify /cart/add accepts form-encoded arrays as items[0][id], items[0][quantity], ...
      // We need to re-wrap the main product AND each addon under the items[] structure.
      // The simplest path: prevent default, use fetch to POST JSON to /cart/add.js, then redirect.
      e.preventDefault();

      const mainVariantId = document.getElementById('variant-id')?.value || form.querySelector('input[name="id"]')?.value;
      const mainQty = parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10);

      const items = [{ id: mainVariantId, quantity: mainQty }];
      checked.forEach(cb => items.push({ id: cb.dataset.variantId, quantity: 1 }));

      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        const textEl = document.getElementById('add-to-cart-text');
        if (textEl) textEl.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(r => r.ok ? r.json() : Promise.reject(r))
      .then(() => { window.location.href = '/cart'; })
      .catch(() => {
        if (submitBtn) {
          submitBtn.disabled = false;
          const textEl = document.getElementById('add-to-cart-text');
          if (textEl) textEl.textContent = 'Add to Cart';
        }
        alert('Could not add to cart. Please try again.');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    const slides = gallery.querySelectorAll('.product__gallery-slide');
    const thumbs = gallery.querySelectorAll('.product__gallery-thumb');

    function pauseVideos() {
      gallery.querySelectorAll('video').forEach(v => { try { v.pause(); } catch {} });
      gallery.querySelectorAll('iframe').forEach(iframe => {
        // Reload iframe to stop YouTube/Vimeo playback
        const src = iframe.src;
        iframe.src = src;
      });
    }

    function activate(idx) {
      pauseVideos();
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => activate(i)));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-order-timeline"] && !Shopify.designMode) return;
  try {
    (function () {
    const timeline = document.querySelector('.product__timeline');
    if (!timeline) return;
    const formatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    timeline.querySelectorAll('[data-step-offset]').forEach(el => {
      const offset = parseInt(el.dataset.stepOffset, 10) || 0;
      const d = new Date();
      d.setDate(d.getDate() + offset);
      el.textContent = formatter.format(d);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
